/**
 * Before/after diff preview for ops mutations.
 * Shows two columns: "Before" and "After" with changed fields highlighted.
 */
export default function DiffPreview({ before, after, label = 'Preview changes' }) {
  if (!before && !after) return null;

  const keys = [...new Set([...Object.keys(before || {}), ...Object.keys(after || {})])];
  const changed = keys.filter(k => JSON.stringify(before?.[k]) !== JSON.stringify(after?.[k]));

  if (changed.length === 0) return <p className="diff-no-changes">No changes</p>;

  return (
    <div className="diff-preview">
      <p className="diff-label">{label}</p>
      <table className="diff-table">
        <thead>
          <tr>
            <th>Field</th>
            <th>Before</th>
            <th>After</th>
          </tr>
        </thead>
        <tbody>
          {changed.map(k => (
            <tr key={k} className="diff-changed">
              <td className="diff-field">{k}</td>
              <td className="diff-before">{String(before?.[k] ?? '—')}</td>
              <td className="diff-after">{String(after?.[k] ?? '—')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
